import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/auth/login";
import Register from "../pages/auth/register";
import Dashboard from "../pages/dashboard/page";
import Sales from "../pages/sales/page";
import Credit from "../pages/credit/page";
import Suppliers from "../pages/suppliers/page";
import Expenses from "../pages/expenses/page";
import Incomes from "../pages/incomes/page";
import Cash from "../pages/cash/page";
import Reports from "../pages/reports/page";
import Settings from "../pages/settings/page";
import AppLayout from "../components/layout/AppLayout";
import ProtectedRoute from "../components/ProtectedRoute";

function LayoutWrapper({ page }: { page: React.ReactNode }) {
  return (
    <ProtectedRoute>
      <AppLayout>{page}</AppLayout>
    </ProtectedRoute>
  );
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/dashboard",
    element: <LayoutWrapper page={<Dashboard />} />,
  },
  {
    path: "/satislar",
    element: <LayoutWrapper page={<Sales />} />,
  },
  {
    path: "/veresiye",
    element: <LayoutWrapper page={<Credit />} />,
  },
  {
    path: "/tedarikciler",
    element: <LayoutWrapper page={<Suppliers />} />,
  },
  {
    path: "/giderler",
    element: <LayoutWrapper page={<Expenses />} />,
  },
  {
    path: "/gelirler",
    element: <LayoutWrapper page={<Incomes />} />,
  },
  {
    path: "/kasa",
    element: <LayoutWrapper page={<Cash />} />,
  },
  {
    path: "/raporlar",
    element: <LayoutWrapper page={<Reports />} />,
  },
  {
    path: "/ayarlar",
    element: <LayoutWrapper page={<Settings />} />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;